module.exports = __webpack_public_path__ + "static/media/2040322000.abbeba93.jpg";